import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import "./register.css";
import {
  Modal,
  Form,
  Icon,
  Input,
  Checkbox,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Button,
  AutoComplete
} from "antd";
import buttonimage from "../../../style/images/login/create account btn.png";
import fbbutton from "../../../style/images/login/facebook sign in btn.png";
import orBar from "../../../style/images/login/OR.png";
import {EmailActivation} from '../Activation/emailactivation'
const contries = [
  {
    value: "Pakistan",
    label: "Pakistan"
  },
  {
    value: "Afganistan",
    label: "Afganistan"
  }
];
export default class RegisterForm extends Component {
  state = {
    modal2Visible: true,
    redirect : false
  };

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
      this.props.disableRegister();
  }
  handleSubmit = e => {
    e.preventDefault();

   this.props.form.validateFields((err, values) => {
     if (!err) {
        console.log("Received values of form: " );
        // this.props.history.push("/emailverification");
        this.setState({redirect:true});
        this.setState({modal2Visible : false });
     
     }
   });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    // if (this.state.redirect) {
    //   return <Redirect to="/emailverification" />;
    // }
    return (
      <Fragment>
        <Modal
          title={
            <div>
              <h1 className="loginTitle">Sign up</h1>
              <img className="facebookShare" src={fbbutton} />
              <br />
              <br />
              <img className="bar" style={{ width: "100%" }} src={orBar} />
            </div>
          }
          centered
          footer={null}
          visible={this.state.modal2Visible}
          onCancel={() => this.setModal2Visible(false)}
        >
          {/* from this poin the login form starts */}

          <Form onSubmit={this.handleSubmit} className="register">
            <Form.Item>
              {getFieldDecorator("countries", {
                initialValue: ["Pakistan"],
                rules: [
                  {
                    type: "array",
                    required: true,
                    message: "Please select your country!"
                  }
                ]
              })(
                <Cascader
                  style={{ backgroundColor: "#343d66", color: "white" }}
                  options={contries}
                />
              )}
            </Form.Item>
            <div className="row">
              <div className="col-xs-6">
                <Form.Item>
                  {getFieldDecorator("firstName", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your First Name!"
                      }
                    ]
                  })(
                    <Input
                      style={{ color: "white" }}
                      // prefix={
                      //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                      // }
                      placeholder="First Name*"
                    />
                  )}
                </Form.Item>
              </div>
              <div className="col-xs-6">
                <Form.Item>
                  {getFieldDecorator("lastName", {
                    rules: [
                      {
                        required: true,
                        message: "Please input your Last Name!"
                      }
                    ]
                  })(
                    <Input
                      style={{ color: "white" }}
                      // prefix={
                      //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                      // }
                      placeholder="Last Name*"
                    />
                  )}
                </Form.Item>
              </div>
            </div>

            <Form.Item>
              {getFieldDecorator("displayName", {
                rules: [
                  { required: true, message: "Please input your Display Name!" }
                ]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  placeholder=" Display Name*"
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("email", {
                rules: [{ required: true, message: "Please input your Email!" }]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  type="Email"
                  placeholder="Email*"
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("password", {
                rules: [
                  { required: true, message: "Please input your Password!" }
                ]
              })(
                <Input
                  // prefix={
                  //   <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  type="password"
                  placeholder="Password*"
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("mobileNumber", {
                rules: [
                  {
                    required: true,
                    message: "Please input your Mobile Number!"
                  }
                ]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  type="Number"
                  placeholder="Mobile Number*"
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("address", {
                rules: [
                  { required: true, message: "Please input your address  !" }
                ]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  placeholder=" Address*"
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("termConditions", {
                valuePropName: "checked",
                initialValue: true
              })(
                <Checkbox style={{ color: "white" , fontFamily:'Gilroy', fontSize:'10px'}}>
                  I have read and agree to the terms and conditions
                </Checkbox>
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("privacyPolicy", {
                valuePropName: "checked",
                initialValue: true
              })(
                <Checkbox style={{ color: "white" , fontFamily:'Gilroy', fontSize:'10px'}}>
                  I have read and agree to the Privacy Policy. I 
                 Understand my rights and  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;how my
                  information 
               will be collected and used as laid out
                  by the website  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; 
                 policy.
                </Checkbox>
              )}
              <br />
              <br />
              <div className="row">
                <div className="col-xs-2 col-sm-2 ">
                  <span />
                </div>
                <div className="col-xs-8 centered">
                  <Button
                    style={{
                      color: "transparent",
                      display: "contents",
                      width: "80%"
                    }}
                    type="image"
                    htmlType="submit"
                  >
                    <img
                      className="login-form-button center"
                      src={buttonimage}
                    />
                  </Button>
                </div>
                <div className="col-xs-2 col-sm-2 ">
                  <span />
                </div>
              </div>

              <p
                style={{
                  fontSize: "small",
                  textAlign: "center",
                  paddingTop: "4%",
                  marginBottom: "-4%",
                  color: "white"
                }}
              >
                Already have an account?{" "}
                <a className = "underline"onClick={() => this.props.gotoLoginPage()}>LOG IN</a>
              </p>
            </Form.Item>
          </Form>
          {/* ending point of the login form */}
        </Modal>
        {this.state.redirect ? (
          <EmailActivation
          disableRegister={this.props.disableRegister}
            {...this.props}
          />
        ) : null}
      </Fragment>
    );
  }
}

export const Register = Form.create({ name: "register" })(RegisterForm);
